module.exports = __webpack_public_path__ + "static/img/broken_heart.750abd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emoji/broken_heart.png
// module id = SPrs
// module chunks = 0